import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { User, UserDto } from '../models';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models/api-response';

@Service()
export class HttpService {
    private httpClient = inject(HttpClient);

    getProfile(): Observable<User> {
        return this.httpClient.get<ApiResponse<UserDto>>('me').pipe(mapDto((response) => new User(response.data)));
    }

    updateLanguage(language: string): Observable<User> {
        return this.httpClient.patch<ApiResponse<UserDto>>('me', { language }).pipe(mapDto((response) => new User(response.data)));
    }
}
